import { createStore } from 'vuex'
import layout from './modules/layout'
import menu from './modules/menu'
import language from "./modules/language"
import chat from './modules/chat'
import products from './modules/products'
import email from './modules/email'
import todo from './modules/todo'
import jobs from './modules/jobs'
import courses from './modules/courses'
import auth from './modules/auth'
import adminAuth from './modules/adminAuth'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    layout,
    menu,
    language,
    chat,
    products,
    email,
    todo,
    jobs,
    courses,
    auth,
    adminAuth
  }
})
